import {
  PostAPI,
  PostAPIWithoutRequest,
  PostAPIWithoutRequestAndKeyData,
} from "src/components/api/helper/apiHelper";

export const Insert = async (request: string) => {
  return PostAPI(request, "CustomerMegaMenuMappingMaster/Insert");
};

export const Select = async () => {
  return PostAPIWithoutRequest("CustomerMegaMenuMappingMaster/Select");
};

export const Delete = async (request: string) => {
  return PostAPI(request, "CustomerMegaMenuMappingMaster/Delete");
};

export const Update = async (request: string) => {
  return PostAPI(request, "CustomerMegaMenuMappingMaster/Update");
};

export const SelectByID = async (request: string) => {
  return PostAPI(request, "CustomerMegaMenuMappingMaster/SelectByID");
};

export const ShowCustomerMegaMenuMappingDetails = async (request: string) => {
  return PostAPI(request, "CustomerMegaMenuMappingMaster/ShowCustomerMegaMenuMappingDetails");
};

export const Select_CustomerMegaMenu = async () => {
  return PostAPIWithoutRequestAndKeyData("CustomerMegaMenuMappingMaster/Select_CustomerMegaMenu");
};